import { openPrivacyPreferences } from "@/services/privacy/privacyConsentService";
import { cn } from "@/lib/utils";

export function PrivacyPreferencesButton({ className, ...props }) {
  return (
    <button
      type="button"
      onClick={openPrivacyPreferences}
      data-testid="privacy-preferences-link"
      className={cn(
        "text-sm text-zinc-400 hover:text-white transition-colors",
        className,
      )}
      {...props}
    >
      Preferências de privacidade
    </button>
  );
}
